/* iSafe · aviso de estoque na pagina de produto (v2: WhatsApp com mascara)
 *
 * O envio de verdade continua sendo o formulario de contato da Shopify: a loja
 * recebe o e-mail com nome, WhatsApp e produto. Este arquivo faz duas coisas
 * alem disso:
 *
 *   1. abre o painel de campos quando o visitante clica no botao;
 *   2. manda uma copia para o CRM, que e onde a lista de espera vive.
 *
 * Regra que vale para tudo aqui: NADA disto pode impedir o envio. Se o CRM
 * estiver fora do ar, o pedido do visitante ja esta indo por e-mail do mesmo
 * jeito. Por isso a copia sai por sendBeacon (ou fetch com keepalive) e
 * qualquer erro morre em silencio.
 *
 * O bloco e' reconstruido pelo tema a cada troca de variante
 * (product-info.js chama updateSourceFromDestination), entao os eventos ficam
 * no document, nunca no elemento.
 */
(function () {
  'use strict';

  var CHAVE_SESSAO = 'isafe_aviso_sessao';

  function sessao() {
    try {
      var s = localStorage.getItem(CHAVE_SESSAO);
      if (!s) {
        s = 'av-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(CHAVE_SESSAO, s);
      }
      return s;
    } catch (e) {
      // navegacao anonima com armazenamento bloqueado: segue sem sessao
      return '';
    }
  }

  function bloco(alvo) {
    return alvo && alvo.closest ? alvo.closest('[data-isafe-aviso]') : null;
  }

  function valor(raiz, seletor) {
    var el = raiz.querySelector(seletor);
    return el && el.value ? el.value.trim() : '';
  }

  // ── WhatsApp no formato (00)00000-0000 ──────────────────────────────────────
  // O numero vai para o CRM e e' por ele que a loja avisa a pessoa. Digitado
  // solto, chegava de todo jeito ("48 99999 8888", "+55 48 999998888"), e numero
  // errado vira aviso que nunca chega. A mascara monta o formato enquanto a
  // pessoa digita e o envio so sai com 10 ou 11 digitos (fixo ou celular).
  function mascaraTelefone(v) {
    var d = String(v || '').replace(/\D/g, '');
    // colado com +55 na frente: o pais nao entra no formato
    if (d.length > 11 && d.slice(0, 2) === '55') d = d.slice(2);
    d = d.slice(0, 11);
    if (!d) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ')' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ')' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ')' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function ehTelefone(el) {
    return el && el.matches && el.matches('input[name="contact[WhatsApp]"]');
  }

  function aplicarMascara(el) {
    var antes = el.value;
    var depois = mascaraTelefone(antes);
    if (depois === antes) return;
    var digitosAteCursor = 0;
    try {
      digitosAteCursor = antes.slice(0, el.selectionStart || 0).replace(/\D/g, '').length;
    } catch (e) {}
    el.value = depois;
    // Cursor onde a pessoa estava: conta os digitos, nao os parenteses.
    try {
      var pos = 0, contados = 0;
      while (pos < depois.length && contados < digitosAteCursor) {
        if (/\d/.test(depois.charAt(pos))) contados++;
        pos++;
      }
      el.setSelectionRange(pos, pos);
    } catch (e) {}
  }

  function formatarTodos() {
    document.querySelectorAll('input[name="contact[WhatsApp]"]').forEach(function (el) {
      if (el.value) aplicarMascara(el);
    });
  }

  document.addEventListener('input', function (ev) {
    if (ehTelefone(ev.target)) aplicarMascara(ev.target);
  });
  // Numero que ja vem preenchido (cliente logado) tambem entra no formato.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', formatarTodos);
  else formatarTodos();

  // Envio so com o numero completo. Esta conferencia vem ANTES da copia para o
  // CRM (o listener de baixo), porque preventDefault aqui cancela o envio inteiro.
  document.addEventListener('submit', function (ev) {
    var raiz = ev.target && ev.target.closest ? ev.target.closest('[data-isafe-aviso]') : null;
    if (!raiz) return;
    var tel = raiz.querySelector('input[name="contact[WhatsApp]"]');
    if (!tel) return;
    var d = (tel.value || '').replace(/\D/g, '');
    if (d.length === 10 || d.length === 11) { tel.setCustomValidity(''); return; }
    ev.preventDefault();
    ev.stopPropagation();
    tel.setCustomValidity('Digite o WhatsApp com DDD, no formato (00)00000-0000.');
    tel.reportValidity();
    tel.addEventListener('input', function limpa() {
      tel.setCustomValidity('');
      tel.removeEventListener('input', limpa);
    });
  });

  document.addEventListener('click', function (ev) {
    var abre = ev.target.closest && ev.target.closest('[data-av-abrir]');
    if (abre) {
      var raizA = bloco(abre);
      if (!raizA) return;
      var painel = raizA.querySelector('[data-av-painel]');
      if (!painel) return;
      painel.hidden = false;
      abre.hidden = true;
      abre.setAttribute('aria-expanded', 'true');
      var primeiro = painel.querySelector('input:not([hidden]):not([type=hidden])');
      if (primeiro) primeiro.focus();
      return;
    }

    var troca = ev.target.closest && ev.target.closest('[data-av-troca]');
    if (troca) {
      var raizT = bloco(troca);
      if (!raizT) return;
      var conta = raizT.querySelector('[data-av-conta]');
      var ident = raizT.querySelector('[data-av-identidade]');
      if (conta) conta.hidden = true;
      if (ident) {
        ident.hidden = false;
        // so agora os campos passam a ser obrigatorios: campo escondido e
        // obrigatorio trava o envio no navegador, sem mensagem util.
        ident.querySelectorAll('input').forEach(function (i) {
          i.required = true;
          i.setAttribute('aria-required', 'true');
        });
        var nome = ident.querySelector('input[type=text]');
        if (nome) { nome.value = ''; nome.focus(); }
        var email = ident.querySelector('input[type=email]');
        if (email) email.value = '';
      }
      raizT.dataset.logado = '0';
    }
  });

  document.addEventListener('submit', function (ev) {
    var raiz = ev.target && ev.target.closest ? ev.target.closest('[data-isafe-aviso]') : null;
    if (!raiz) return;

    var destino = (raiz.dataset.crm || '').trim();
    if (!destino) return; // CRM desligado no painel: segue so pelo e-mail

    var corpo = {
      sessao: sessao(),
      nome: valor(raiz, 'input[name="contact[name]"]'),
      whatsapp: valor(raiz, 'input[name="contact[WhatsApp]"]'),
      email: valor(raiz, 'input[name="contact[email]"]'),
      logado: raiz.dataset.logado === '1',
      cliente_shopify_id: raiz.dataset.clienteId || null,
      produto: {
        id: Number(raiz.dataset.produtoId) || null,
        titulo: raiz.dataset.produtoTitulo || '',
        url: raiz.dataset.produtoUrl || '',
        variante_id: Number(valor(raiz, 'input[name="contact[Variant ID]"]')) || null,
        variante_titulo: raiz.dataset.varianteTitulo || '',
        sku: raiz.dataset.sku || ''
      },
      origem: 'pagina-produto'
    };

    // O envio sai no exato momento em que a pagina comeca a sair do ar, porque o
    // formulario nativo navega. Dois cuidados por causa disso:
    //
    //   1. text/plain. Content-Type "application/json" nao esta na lista segura
    //      do CORS e obriga o navegador a mandar antes um OPTIONS de permissao.
    //      Esse pedido extra costuma nao terminar a tempo durante a navegacao, e
    //      o aviso se perde. text/plain dispensa o OPTIONS. O corpo continua
    //      sendo JSON: quem recebe so precisa aceitar esse tipo tambem.
    //   2. sendBeacon primeiro. E' a API feita para isto e sobrevive a saida da
    //      pagina. Onde nao existir, cai no fetch com keepalive.
    var texto = JSON.stringify(corpo);
    try {
      var mandou = false;
      if (navigator.sendBeacon) {
        mandou = navigator.sendBeacon(destino, new Blob([texto], { type: 'text/plain;charset=UTF-8' }));
      }
      if (!mandou) {
        fetch(destino, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: texto,
          keepalive: true,
          mode: 'cors'
        }).catch(function () {});
      }
    } catch (e) {
      // nunca atrapalhar o envio: o e-mail para a loja ja esta a caminho
    }
  });
})();
